import React from 'react';

const WhyEmployers: React.FC = () => {
    return (
        <section className="relative px-4 overflow-x-hidden" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
            <div className="container mx-auto max-w-[1640px]">
                {/* Desktop Title */}
                <h2
                    className="hidden lg:block text-left mb-16"
                    style={{
                        fontFamily: 'Manrope',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: 'clamp(56px, 7vw, 104px)',
                        lineHeight: 'clamp(66px, 8vw, 128px)',
                        letterSpacing: '-0.05em',
                        color: '#FFFFFF',
                    }}
                >
                    Why employers choose Hush
                </h2>

                {/* Desktop Layout - Main Container - 1354px width */}
                <div
                    className="hidden lg:block"
                    style={{
                        position: 'relative',
                        width: '1354px',
                        maxWidth: '100%',
                        height: '620px',
                        margin: '0 auto',
                    }}
                >

                {/* Card 1: Direct Access - Small Card (Top Left) */}
                <div
                    style={{
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        padding: '20px',
                        gap: '10px',
                        position: 'absolute',
                        width: '340px',
                        height: '274px',
                        left: '354px',
                        top: '0px',
                        background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '40px',
                    }}
                >
                    {/* Icon */}
                    <img
                        src="/career/direct.svg"
                        alt="Direct Access"
                        style={{
                            width: '136px',
                            height: '99px',
                            objectFit: 'contain',
                            flexShrink: 0,
                        }}
                    />

                    {/* Content */}
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '16px 0px',
                            gap: '16px',
                            width: '300px',
                            height: '127px',
                            flex: 'none',
                            alignSelf: 'stretch',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                padding: '0px',
                                gap: '20px',
                                width: '300px',
                            }}
                        >
                            <h3
                                style={{
                                    width: '300px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    fontSize: '24px',
                                    lineHeight: '27px',
                                    color: '#FFFFFF',
                                    textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)',
                                    margin: 0,
                                }}
                            >
                                Direct Access
                            </h3>
                            <p
                                style={{
                                    width: '300px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    margin: 0,
                                }}
                            >
                                Source from a talent pool before they're already on the market.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Card 2: Higher Efficiency - Wide Card (Top Right) */}
                <div
                    style={{
                        boxSizing: 'border-box',
                        position: 'absolute',
                        width: '620px',
                        height: '274px',
                        left: '734px',
                        top: '0px',
                        background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '40px',
                        padding: '20px',
                    }}
                >
                    {/* Content */}
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '16px 0px',
                            gap: '16px',
                            width: '580px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                padding: '0px',
                                gap: '20px',
                                width: '580px',
                            }}
                        >
                            <h3
                                style={{
                                    width: '580px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    fontSize: '24px',
                                    lineHeight: '27px',
                                    color: '#FFFFFF',
                                    textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)',
                                    margin: 0,
                                }}
                            >
                                Higher Efficiency
                            </h3>
                            <p
                                style={{
                                    width: '580px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    margin: 0,
                                }}
                            >
                                AI handles outreach, scheduling, and filtering, so your team saves time
                            </p>
                        </div>
                    </div>

                    {/* Icon and Description Below */}
                    <div style={{ display: 'flex', gap: '20px', marginTop: '16px', alignItems: 'flex-start' }}>
                        {/* Icon */}
                        <img
                            src="/career/efficiency.svg"
                            alt="Higher Efficiency"
                            style={{
                                width: '136px',
                                height: '99px',
                                objectFit: 'contain',
                                flexShrink: 0,
                            }}
                        />

                        <p
                            style={{
                                width: '392px',
                                fontFamily: 'Inter',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: '24px',
                                textAlign: 'justify',
                                color: 'rgba(255, 255, 255, 0.6)',
                                margin: 0,
                            }}
                        >
                            Hush's AI recruiter manages the repetitive, time-consuming parts of hiring — outreach, scheduling, and filtering. Instead of chasing resumes, your team engages only with qualified candidates who are genuinely interested.
                        </p>
                    </div>
                </div>

                {/* Card 3: Quality Over Quantity - Wide Card (Bottom Left) */}
                <div
                    style={{
                        boxSizing: 'border-box',
                        position: 'absolute',
                        width: '620px',
                        height: '274px',
                        left: '354px',
                        top: '314px',
                        background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '40px',
                        padding: '20px',
                    }}
                >
                    {/* Content */}
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '16px 0px',
                            gap: '16px',
                            width: '580px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                padding: '0px',
                                gap: '20px',
                                width: '580px',
                            }}
                        >
                            <h3
                                style={{
                                    width: '580px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    fontSize: '24px',
                                    lineHeight: '27px',
                                    color: '#FFFFFF',
                                    textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)',
                                    margin: 0,
                                }}
                            >
                                Quality Over Quantity
                            </h3>
                            <p
                                style={{
                                    width: '580px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    margin: 0,
                                }}
                            >
                                Traditional recruiting brings you noise
                            </p>
                        </div>
                    </div>

                    {/* Icon and Description Below */}
                    <div style={{ display: 'flex', gap: '20px', marginTop: '16px', alignItems: 'flex-start' }}>
                        {/* Icon */}
                        <img
                            src="/career/quality.svg"
                            alt="Quality Over Quantity"
                            style={{
                                width: '136px',
                                height: '99px',
                                objectFit: 'contain',
                                flexShrink: 0,
                            }}
                        />

                        <p
                            style={{
                                width: '392px',
                                fontFamily: 'Inter',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: '24px',
                                textAlign: 'justify',
                                color: 'rgba(255, 255, 255, 0.6)',
                                margin: 0,
                            }}
                        >
                            Hush flips the script, we make sure that we are only sharing the most qualified candidates with you. Our pre-screening and advanced matching ensures that your team is seeing the best talent for the role.
                        </p>
                    </div>
                </div>

                {/* Card 4: Scalable Recruiting - Small Card (Bottom Right) */}
                <div
                    style={{
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        padding: '20px',
                        gap: '10px',
                        position: 'absolute',
                        width: '340px',
                        height: '274px',
                        left: '1014px',
                        top: '314px',
                        background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '40px',
                    }}
                >
                    {/* Icon */}
                    <img
                        src="/career/scalable.svg"
                        alt="Scalable Recruiting"
                        style={{
                            width: '136px',
                            height: '99px',
                            objectFit: 'contain',
                            flexShrink: 0,
                        }}
                    />

                    {/* Content */}
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '16px 0px',
                            gap: '16px',
                            width: '300px',
                            height: '127px',
                            flex: 'none',
                            alignSelf: 'stretch',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                padding: '0px',
                                gap: '20px',
                                width: '300px',
                            }}
                        >
                            <h3
                                style={{
                                    width: '300px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    fontSize: '24px',
                                    lineHeight: '27px',
                                    color: '#FFFFFF',
                                    textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)',
                                    margin: 0,
                                }}
                            >
                                Scalable Recruiting
                            </h3>
                            <p
                                style={{
                                    width: '300px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    margin: 0,
                                }}
                            >
                                Whether hiring one role or hundreds, Hush grows with your needs.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile Layout - Stacked vertical cards */}
            <div className="lg:hidden max-w-[600px] mx-auto">
                {/* Section Title */}
                <h2
                    className="text-left mb-8"
                    style={{
                        fontFamily: 'Manrope',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: 'clamp(28px, 7vw, 128px)',
                        lineHeight: 'clamp(34px, 8vw, 175px)',
                        letterSpacing: '-0.05em',
                        color: '#FFFFFF',
                    }}
                >
                    Why employers choose Hush
                </h2>

                {/* Cards stacked vertically */}
                <div className="flex flex-col gap-6">
                    {/* Card 1: Direct Access */}
                    <div
                        style={{
                            boxSizing: 'border-box',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            padding: '20px',
                            gap: '16px',
                            background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                            border: '1px solid rgba(255, 255, 255, 0.15)',
                            boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '24px',
                        }}
                    >
                        <img src="/career/direct.svg" alt="Direct Access" style={{ width: '80px', height: '60px', objectFit: 'contain' }} />
                        <div>
                            <h3 style={{ fontFamily: 'Inter', fontWeight: 700, fontSize: '20px', lineHeight: '24px', color: '#FFFFFF', textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)', margin: '0 0 12px 0' }}>
                                Direct Access
                            </h3>
                            <p style={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: 'rgba(255, 255, 255, 0.6)', margin: 0 }}>
                                Source from a talent pool before they're already on the market.
                            </p>
                        </div>
                    </div>

                    {/* Card 2: Higher Efficiency */}
                    <div
                        style={{
                            boxSizing: 'border-box',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            padding: '20px',
                            gap: '16px',
                            background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                            border: '1px solid rgba(255, 255, 255, 0.15)',
                            boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '24px',
                        }}
                    >
                        <div>
                            <h3 style={{ fontFamily: 'Inter', fontWeight: 700, fontSize: '20px', lineHeight: '24px', color: '#FFFFFF', textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)', margin: '0 0 12px 0' }}>
                                Higher Efficiency
                            </h3>
                            <p style={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: 'rgba(255, 255, 255, 0.6)', margin: '0 0 16px 0' }}>
                                AI handles outreach, scheduling, and filtering, so your team saves time
                            </p>
                        </div>
                        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', width: '100%' }}>
                            <img src="/career/efficiency.svg" alt="Higher Efficiency" style={{ width: '80px', height: '60px', objectFit: 'contain', flexShrink: 0 }} />
                            <p style={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: 'rgba(255, 255, 255, 0.6)', margin: 0, flex: 1 }}>
                                Hush's AI recruiter manages the repetitive, time-consuming parts of hiring — outreach, scheduling, and filtering. Instead of chasing resumes, your team engages only with qualified candidates who are genuinely interested.
                            </p>
                        </div>
                    </div>

                    {/* Card 3: Quality Over Quantity */}
                    <div
                        style={{
                            boxSizing: 'border-box',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            padding: '20px',
                            gap: '16px',
                            background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                            border: '1px solid rgba(255, 255, 255, 0.15)',
                            boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '24px',
                        }}
                    >
                        <div>
                            <h3 style={{ fontFamily: 'Inter', fontWeight: 700, fontSize: '20px', lineHeight: '24px', color: '#FFFFFF', textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)', margin: '0 0 12px 0' }}>
                                Quality Over Quantity
                            </h3>
                            <p style={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: 'rgba(255, 255, 255, 0.6)', margin: '0 0 16px 0' }}>
                                Traditional recruiting brings you noise
                            </p>
                        </div>
                        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', width: '100%' }}>
                            <img src="/career/quality.svg" alt="Quality Over Quantity" style={{ width: '80px', height: '60px', objectFit: 'contain', flexShrink: 0 }} />
                            <p style={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: 'rgba(255, 255, 255, 0.6)', margin: 0, flex: 1 }}>
                                Hush flips the script, we make sure that we are only sharing the most qualified candidates with you. Our pre-screening and advanced matching ensures that your team is seeing the best talent for the role.
                            </p>
                        </div>
                    </div>

                    {/* Card 4: Scalable Recruiting */}
                    <div
                        style={{
                            boxSizing: 'border-box',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            padding: '20px',
                            gap: '16px',
                            background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                            border: '1px solid rgba(255, 255, 255, 0.15)',
                            boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '24px',
                        }}
                    >
                        <img src="/career/scalable.svg" alt="Scalable Recruiting" style={{ width: '80px', height: '60px', objectFit: 'contain' }} />
                        <div>
                            <h3 style={{ fontFamily: 'Inter', fontWeight: 700, fontSize: '20px', lineHeight: '24px', color: '#FFFFFF', textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)', margin: '0 0 12px 0' }}>
                                Scalable Recruiting
                            </h3>
                            <p style={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: 'rgba(255, 255, 255, 0.6)', margin: 0 }}>
                                Whether hiring one role or hundreds, Hush grows with your needs.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </section>
    );
};

export default WhyEmployers;
